import _ from "lodash"
import { useCallback } from "react"

export const useUrlParamsDecode = () => {

    const isJsonString = useCallback((str: string): boolean => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }, [])

    return useCallback((uri: string) => {
        const search_params = new URLSearchParams(uri.replace(/.*\?(.*)/g, '$1'))
        const result = {}
        search_params.forEach((value: string, key: string, parent: URLSearchParams) => {
            if (/^http/.test(key)) {
                return;
            }
            
            result[key.replace(/\[\]$/, '')] = /\[\]$/.test(key) 
                ? parent.getAll(key).map((item) => (isJsonString(item) ? JSON.parse(item) : item))
                : (isJsonString(value) ? JSON.parse(value) : value)
        })
        return result
    }, [])
}
